/* pw-2mm-special.js — Plåtwebb 2 mm specialbeställning
   Strategi:
     - Toggle visar/döljer formuläret med smooth scroll-in
     - Inför submit: läs aktuella värden från plat-kalkylator-instansen
       (om den finns på sidan) och skriv in i hidden fields
     - Auto-uppdatera "Din specifikation"-rutan när kalkylator-värden ändras

   Robusthet:
     - Fungerar även utan kalkylator (formuläret skickas ändå)
     - Värden hämtas via DOM (input-element), inte via JS-state — det gör
       lösningen oberoende av plat-kalkylator.js's interna implementation
*/

(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getCalcValues() {
    var calc = document.getElementById('plat-kalkylator');
    if (!calc) return null;

    var values = { dims: [], material: '', material_label: '', color: '', quantity: 1 };

    // Mått: alla pw-field--slider rader
    $$('.pw-field--slider', calc).forEach(function (row) {
      var label = row.querySelector('.pw-field__label');
      var input = row.querySelector('input[type="range"], input[type="number"].pw-field__manual-input');
      var unitEl = row.querySelector('.pw-field__manual-unit') || row.querySelector('.pw-field__val');
      if (label && input) {
        var unit = unitEl ? unitEl.textContent.replace(input.value, '').trim() : 'mm';
        // Plocka bara enhet (mm/grader) som första ord
        var unitClean = unit.replace(/[(].*[)]/, '').trim().split(/\s+/)[0] || 'mm';
        values.dims.push({
          label: label.textContent.trim(),
          value: input.value,
          unit: unitClean
        });
      }
    });

    // Vinklar (number-inputs i pw-field--inline med radens närvaro av angles-container)
    var angBox = calc.querySelector('[data-pw-angles]');
    if (angBox) {
      $$('.pw-field--inline', angBox).forEach(function (row) {
        var label = row.querySelector('.pw-field__label');
        var input = row.querySelector('input[type="number"]');
        var unit = row.querySelector('.pw-field__unit');
        if (label && input) {
          values.dims.push({
            label: label.textContent.trim(),
            value: input.value,
            unit: unit ? unit.textContent.trim() : '°'
          });
        }
      });
    }

    // Material: vald radio
    var mat = calc.querySelector('input[name="pw-material"]:checked');
    if (mat) {
      values.material = mat.value;
      var matLbl = mat.closest('.pw-material');
      if (matLbl) {
        var span = matLbl.querySelector('span');
        // Plocka bara label-texten, inte surcharge
        var matText = span ? span.firstChild.textContent.trim() : mat.value;
        values.material_label = matText;
      }
    }

    // Antal
    var qty = calc.querySelector('#pw-qty');
    if (qty) values.quantity = qty.value || '1';

    return values;
  }

  function buildSpecsString(values) {
    if (!values || !values.dims.length) return '(inga värden valda i kalkylatorn)';
    return values.dims.map(function (d) {
      return d.label + ': ' + d.value + ' ' + d.unit;
    }).join(' · ');
  }

  function syncToForm(section) {
    var values = getCalcValues();
    if (!values) return;

    var specsField = section.querySelector('[data-pw-2mm-specs]');
    var matField = section.querySelector('[data-pw-2mm-material]');
    var qtyField = section.querySelector('[data-pw-2mm-quantity]');
    if (specsField) specsField.value = buildSpecsString(values);
    if (matField) matField.value = values.material_label || values.material || '';
    if (qtyField) qtyField.value = values.quantity;

    // Uppdatera summary-vyn
    var summaryDims = section.querySelector('[data-pw-2mm-summary-dims]');
    var summaryMat = section.querySelector('[data-pw-2mm-summary-material]');
    var summaryQty = section.querySelector('[data-pw-2mm-summary-qty]');
    if (summaryDims) summaryDims.textContent = buildSpecsString(values);
    if (summaryMat) summaryMat.textContent = values.material_label || values.material || '—';
    if (summaryQty) summaryQty.textContent = values.quantity || '1';
  }

  function init() {
    var sections = $$('[data-pw-2mm]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var details = section.querySelector('[data-pw-2mm-details]');
      var form = section.querySelector('form');

      // Sync värden direkt + lyssna på kalkylator-changes
      syncToForm(section);
      var calc = document.getElementById('plat-kalkylator');
      if (calc) {
        calc.addEventListener('input', function () { syncToForm(section); });
        calc.addEventListener('change', function () { syncToForm(section); });
      }

      // När detaljen öppnas — sync direkt + smooth scroll
      if (details) {
        details.addEventListener('toggle', function () {
          if (details.open) {
            syncToForm(section);
            setTimeout(function () {
              details.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 50);
          }
        });
      }

      // Avbryt-knapp stänger details
      var cancel = section.querySelector('[data-pw-2mm-cancel]');
      if (cancel) {
        cancel.addEventListener('click', function () {
          if (details) details.open = false;
        });
      }

      // Innan submit: en sista sync så hidden-fields är aktuella
      if (form) {
        form.addEventListener('submit', function () {
          syncToForm(section);
        });
      }

      // Om formuläret postats (success-state) → öppna details automatiskt
      if (section.querySelector('.pw-2mm__success') && details) {
        details.open = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();